import { AlertTriangle, Euro } from "lucide-react";

function ChevronRightIcon() {
  return (
    <svg className="w-4 h-4 text-orange-300 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

/**
 * Banner mostrati in cima alla pagina del Giro selezionato:
 *  - Articoli non-Triolo senza prezzo indicato (rosso)
 *  - Estratto conto cliente con saldo > 0 (arancio, cliccabile)
 *
 * Estratto da GiriOrdineRapido.jsx per snellire il file principale.
 */
export function GiroStopBanners({ noPriceCount, saldoAperto, nFattureAperte, onOpenEstratto }) {
  return (
    <>
      {noPriceCount > 0 && (
        <div
          className="w-full mb-4 p-3 rounded-lg border border-red-500/40 bg-red-500/10 flex items-center gap-3"
          data-testid="no-price-warning-banner"
        >
          <AlertTriangle className="w-5 h-5 text-red-400 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-red-300 text-sm font-semibold">
              {noPriceCount === 1
                ? "1 articolo senza prezzo indicato"
                : `${noPriceCount} articoli senza prezzo indicato`}
            </p>
            <p className="text-red-200/80 text-[11px]">
              Imposta sconti o prezzo manuale per favorire la fatturazione.
            </p>
          </div>
        </div>
      )}

      {Number(saldoAperto) > 0 && (
        <button
          onClick={onOpenEstratto}
          data-testid="estratto-conto-banner"
          className="w-full mb-4 p-3 rounded-lg border border-orange-500/40 bg-gradient-to-r from-orange-500/10 to-red-500/5 hover:from-orange-500/20 hover:to-red-500/10 transition-colors flex items-center gap-3 text-left"
        >
          <AlertTriangle className="w-5 h-5 text-orange-400 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-orange-300 text-sm font-semibold flex items-center gap-1">
              <Euro className="w-3.5 h-3.5" />
              {Number(saldoAperto).toLocaleString("it-IT", { style: "currency", currency: "EUR" })} da incassare
            </p>
            <p className="text-zinc-400 text-[11px]">
              {nFattureAperte} fattur{nFattureAperte === 1 ? "a" : "e"} aperte · tocca per dettaglio
            </p>
          </div>
          <ChevronRightIcon />
        </button>
      )}
    </>
  );
}
